import { Grid, Flex, Input } from "@mantine/core";
import type { CSSProperties } from "react";
import Cell from "../Cell/Cell";

type FlexDirection = Pick<CSSProperties, "flexDirection">;

interface Props {
  subUuid: string;
  cols: any;
  flex?: string;
  sectionIndex?: number;
  rowIndex?: number;
  required: boolean;
  value?: any;
  direction?: FlexDirection;
}

const Sub = ({
  subUuid,
  cols,
  flex,
  sectionIndex,
  rowIndex,
  required,
  value,
  direction,
}: Props) => {
  // const [insertedTankName, setInsertedTankName] = useState<
  //   string | undefined
  // >();
  // const isOilRec =
  //   cols &&
  //   Object.values(cols).some((col: any) => col.unit?.includes("oilrec"));

  // useEffect(() => {
  //   if (!isOilRec || !cols) return;
  //   Object.values(cols).forEach((col: any) => {
  //     if (isOilRec && col.unit === "text" && !col.suffix) {
  //       setInsertedTankName(col.value);
  //     }
  //   });
  // }, [isOilRec, cols, sectionIndex, rowIndex]);
  const cellsArr = Object.entries(cols ?? {}).map(
    ([uuid, cell]: [string, any]) => ({
      uuid,
      ...cell,
    }),
  );

  const supportsGrid = cellsArr.some(
    cell =>
      typeof cell.gridRow === "number" && typeof cell.gridCol === "number",
  );

  if (supportsGrid) {
    const rowsMap: Record<number, any[]> = {};
    cellsArr.forEach(cell => {
      const r = cell.gridRow ?? 0;
      if (!rowsMap[r]) rowsMap[r] = [];
      rowsMap[r].push(cell);
    });

    const sortedRowKeys = Object.keys(rowsMap)
      .map(Number)
      .sort((a, b) => a - b);

    const maxCols = Math.max(...sortedRowKeys.map(r => rowsMap[r].length));

    return (
      <>
        {sortedRowKeys.map(rowIdx => {
          const rowCells = rowsMap[rowIdx].sort(
            (a, b) => (a.gridCol ?? 0) - (b.gridCol ?? 0),
          );
          const isSingleCellRow = rowCells.length === 1;

          return (
            <Grid key={rowIdx} gutter={5} columns={maxCols}>
              {rowCells.map(cell => (
                <Grid.Col
                  key={cell.uuid}
                  span={isSingleCellRow ? maxCols : (cell.span ?? 1)}
                  style={{
                    display: "flex",
                    gap: 5,
                    textAlign: "center",
                    marginTop: rowIdx !== 0 ? 2.5 : 0,
                  }}>
                  {cell.label && (
                    <Input
                      readOnly
                      styles={{
                        input: { textAlign: "center", pointerEvents: "none" },
                      }}
                      value={cell.label}
                    />
                  )}
                  <Cell
                    style={
                      cell.unit !== "check" ? { flex: 1 } : { marginLeft: 8 }
                    }
                    unitType={cell.unit}
                    uuid={cell.uuid}
                    subUuid={subUuid}
                    rowIndex={rowIndex}
                    sectionIndex={sectionIndex}
                    cellId={cell.id}
                    cols={cell?.content?.cols}
                    flex={flex}
                    required={required}
                    // insertedTankName={insertedTankName}
                    insertedValue={value}
                    {...cell}
                  />
                </Grid.Col>
              ))}
            </Grid>
          );
        })}
      </>
    );
  } else {
    return (
      <Flex w="100%" gap={5} direction={direction ?? "column"}>
        {cellsArr.map((cell, i) => (
          <Flex
            key={cell.uuid}
            style={{
              gap: 5,
              boxSizing: "content-box",
              width: "100%",
            }}>
            {cell.label && (
              <Input
                readOnly
                styles={{
                  input: { textAlign: "center", pointerEvents: "none" },
                }}
                value={cell.label}
              />
            )}
            <Cell
              style={cell.unit !== "check" ? { flex: 1 } : { marginLeft: 8 }}
              unitType={cell.unit}
              uuid={cell.uuid}
              subUuid={subUuid}
              rowIndex={rowIndex}
              sectionIndex={sectionIndex}
              cellId={cell.id}
              cols={cell?.content?.cols}
              flex={flex}
              required={required}
              // insertedTankName={insertedTankName}
              insertedValue={value}
              {...cell}
            />
          </Flex>
        ))}
      </Flex>
    );
  }
};

export default Sub;
